<google-map
	height="160px"
	width="240px"
	[center]="mapCenter"
	[zoom]="zoom"
	[options]="mapOptions"
	data-automation-id="google-map"
>
	@for (marker of markers; track marker?.position?.lat + ',' + marker?.position?.lng) {
		<map-marker [position]="marker.position" data-automation-id="google-map-marker"> </map-marker>
	}
</google-map>
